import { TFunction } from 'next-i18next'

export const HEIGHT = [
  { label: ' 4\'10" ', value: ' 4\'10" ' },
  { label: ' 4\'11" ', value: ' 4\'11" ' },
  { label: ' 5\'0" ', value: ' 5\'0" ' },
  { label: ' 5\'1" ', value: ' 5\'1" ' },
  { label: ' 5\'2" ', value: ' 5\'2" ' },
  { label: ' 5\'3" ', value: ' 5\'3" ' },
  { label: ' 5\'4" ', value: ' 5\'4" ' },
  { label: ' 5\'5" ', value: ' 5\'5" ' },
  { label: ' 5\'6" ', value: ' 5\'6" ' },
  { label: ' 5\'7" ', value: ' 5\'7" ' },
  { label: ' 5\'8" ', value: ' 5\'8" ' },
  { label: ' 5\'9" ', value: ' 5\'9" ' },
  { label: ' 5\'10" ', value: ' 5\'10" ' },
  { label: ' 5\'11" ', value: ' 5\'11" ' },
  { label: ' 6\'1" ', value: ' 6\'1" ' },
  { label: ' 6\'2" ', value: ' 6\'2" ' },
  { label: ' 6\'3" ', value: ' 6\'3" ' },
  { label: ' 6\'4" ', value: ' 6\'4" ' },
  { label: ' 6\'5" ', value: ' 6\'5" ' },
  { label: ' 6\'6" ', value: ' 6\'6" ' },
]

export const WEIGHT = [
  { label: '91-100', value: '91-100' },
  { label: '101-110', value: '101-110' },
  { label: '111-120', value: '111-120' },
  { label: '121-130', value: '121-130' },
  { label: '131-140', value: '131-140' },
  { label: '141-150', value: '141-150' },
  { label: '151-160', value: '151-160' },
  { label: '161-170', value: '161-170' },
  { label: '171-180', value: '171-180' },
  { label: '181-190', value: '181-190' },
  { label: '191-200', value: '191-200' },
  { label: '201-210', value: '201-210' },
  { label: '211-220', value: '211-220' },
  { label: '221-230', value: '221-230' },
  { label: '231-240', value: '231-240' },
  { label: '241-250', value: '241-250' },
  { label: '250+', value: '250+' },
]

export enum SLIDER_OPTION_NAMES {
  PriceForQuality = 'Price For Quality',
  Fit = 'Fit',
  Length = 'Length',
}

export const BASE_SLIDER_OPTIONS = [SLIDER_OPTION_NAMES.PriceForQuality]

export const FULL_REVIEW_SLIDER_OPTIONS = [...BASE_SLIDER_OPTIONS, SLIDER_OPTION_NAMES.Length, SLIDER_OPTION_NAMES.Fit]

// @i18n-ignore-start
export const FULL_REVIEW_PRODUCT_TYPES = [
  'bottoms',
  'sweaters',
  'tops',
  'shirts',
  'dresses',
  'fleece',
  'loungewear',
  't-shirts',
  'skirts',
  'SLEEPWEAR',
  'LIGHTWEIGHT KNIT TOPS',
  'WOVEN TOPS',
  'WOVEN TOPS & BLOUSES',
  'DRESSES & JUMPSUITS',
]
// @i18n-ignore-end

export const getIsProductRecommendedRadioOptions = (t: TFunction) => {
  return [{ label: t('yes_v1') }, { label: t('no') }]
}

// @i18n-ignore-start
export const FIELD_ID_WITH_ERROR_FEATURE = {
  reviewTitle: 'reviewTitle',
  reviewRating: 'reviewRating',
  author: 'author',
  email: 'email',
  reviewMessage: 'reviewMessage',
  photos: 'photos',
}

export const ERROR_CONFIG_IN_ORDER: {
  fieldId: string
  errorStateKey: string
}[] = [
  {
    fieldId: FIELD_ID_WITH_ERROR_FEATURE.reviewTitle,
    errorStateKey: 'reviewTitle',
  },
  {
    fieldId: FIELD_ID_WITH_ERROR_FEATURE.reviewRating,
    errorStateKey: 'reviewRating',
  },
  {
    fieldId: FIELD_ID_WITH_ERROR_FEATURE.author,
    errorStateKey: 'author',
  },
  {
    fieldId: FIELD_ID_WITH_ERROR_FEATURE.email,
    errorStateKey: 'email',
  },
  {
    fieldId: FIELD_ID_WITH_ERROR_FEATURE.reviewMessage,
    errorStateKey: 'reviewMessage',
  },
  {
    fieldId: FIELD_ID_WITH_ERROR_FEATURE.photos,
    errorStateKey: 'photosSizeExceeded',
  },
]
// @i18n-ignore-end

export const initialErrorState = {
  author: false,
  email: false,
  reviewTitle: false,
  reviewRating: false,
  reviewMessage: false,
  photosSizeExceeded: false,
}

export const initialAttributeMap = {}

export const RANGE_BALL_PERCENTAGE_MOBILE = [-1.2, 21, 46, 71, 93]

export const RANGE_BALL_PERCENTAGE_DESKTOP = [-1, 23.5, 48.6, 73.7, 98.2]
export const MAX_PHOTOS_SIZE_IN_BYTES = 1000000 * 10
export const PHOTOS_SIZE_EXCEEDED = 'photosSizeExceeded'

export const REVIEW_TITLE = 'reviewTitle'
export const MAX_LENGTH_OF_REVIEW_TITLE = 256
export const ADDRESS_FORM_FIELDS = {
  zip: {
    label: 'Zip code',
    key: 'zip',
  },
  phone: {
    label: 'Phone',
    key: 'phone',
  },
}

export enum REVIEW_ATTRIBUTES {
  ABOUT_YOU = 'aboutYou',
  ABOUT_PRODUCT = 'aboutProduct',
  SIZE_PURCHASED = 'sizePurchased',
  DELIVERY_EXPERIENCE = 'deliveryExperience',
}
